import {
  CALL_API,
} from 'redux-api-middleware'
import { sessionService } from 'redux-react-session'
// import {
//   push,
// } from 'react-router-redux'

import {
  handleLogin,
  // handleLoginForRegister,
  // submitVerify,
  uploadVerifyImageForInstructor,
  // submitVerifyForInstructer,
} from '../actions'

import {
  LOGIN_EP,
  // VERIFY_EP,
  // LOGIN_FB_EP,
  // LOGIN_GG_EP,
  VERIFY_IMAGE_EP,
  REGISTER_TUTOR_FORM_EP
} from '../constant'
import {
  changeRoute,
} from '../actions'
import {
  messagingToLine,
} from '../components/LineStudentRegister/actions'
import {
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  RESET_STATUS_RESPONSE,
  SIGNUP_FAILURE,
  LOAD_LEVEL_REQUEST,
  LOAD_LEVEL_SUCCESS,
  LOAD_LEVEL_FAILURE,
  REGISTER_NEWUSER_REQUEST,
  REGISTER_NEWUSER_SUCCESS,
  REGISTER_NEWUSER_FAILURE,
  TUTOR_REQUEST,
  TUTOR_SUCCESS,
  TUTOR_FAILURE,
  LOAD_LISTTUTOR_REQUEST,
  LOAD_LISTTUTOR_SUCCESS,
  LOAD_LISTTUTOR_FAILURE,
} from './types'

import { token } from '../utils'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
// export const onSubmit = (endPoint, registerForm) => ({
//   type: SIGNUP_REQUEST,
//   payload: fetch(endPoint, {
//     method: 'POST',
//     body: JSON.stringify(registerForm),
//     headers: {
//       Accept: 'application/json',
//       'Content-Type': 'application/json',
//     },
//   }),
// })
export const onSubmit = (endpoint, registerForm, redirect = null) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: JSON.stringify(registerForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-session-token': token,
          'server-name': 'deknerd',
        },
        types: [SIGNUP_REQUEST,
          {
            type: SIGNUP_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              await dispatch(handleLogin(LOGIN_EP, { email: registerForm.email, password: registerForm.password }, redirect))
              // redirect !== null ? window.location.replace(redirect) : window.location.replace('/instructor/review')
              return response
            },
          },
          {
            type: SIGNUP_FAILURE,
            payload: async (action, state, res) => {
              return res.status
            },
          },
        ],
      },
    })
  }
}
export const onRegistorInstructor = (endpoint, registerForm, registerFormInstructor, file, redirect = null) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: JSON.stringify(registerForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-session-token': token,
          'server-name': 'deknerd',
        },
        types: [SIGNUP_REQUEST,
          {
            type: SIGNUP_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              const { tokenWeb } = response
              // await dispatch(handleLoginForRegister(LOGIN_EP, { email: registerForm.email, password: registerForm.password }, redirect))
              await dispatch(uploadVerifyImageForInstructor(VERIFY_IMAGE_EP, file, tokenWeb, { ...registerFormInstructor }, redirect))
              // await dispatch(submitVerifyForInstructer(VERIFY_EP, { ...registerFormInstructor, imagePassportId: 'test' }, tokenWeb))
              return response
            },
          },
          {
            type: SIGNUP_FAILURE,
            payload: async (action, state, res) => {
              return res.status
            },
          },
        ],
      },
    })
  }
}

export const onRegistortutor = (endpoint, registerForm, slugName) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'PUT',
        body: JSON.stringify(registerForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-session-token': token,
          'server-name': 'deknerd',
        },
        types: [TUTOR_REQUEST,
          {
            type: TUTOR_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              const { tokenWeb } = response
              
              if(sessionStorage.getItem("jobId") !== null){
                const jobId = sessionStorage.getItem("jobId")
                const lineTutor = sessionStorage.getItem("lineTutor")
                await sessionStorage.clear()
                await dispatch(changeRoute(`/lineFormDetail/${jobId}/${lineTutor}`))
              }else {
                await dispatch(changeRoute(`/tutorRegister/${slugName}/success`))
              }

              return response
            },
          },
          {
            type: TUTOR_FAILURE,
            payload: async (action, state, res) => {
              return res.status
            },
          },
        ],
      },
    })
  }
}
export const loadListTutor = (endpoint) => {
  console.log(endpoint)
  return {
    [CALL_API]: {
      endpoint,
      method: 'GET',
      headers,
      types: [
        LOAD_LISTTUTOR_REQUEST, LOAD_LISTTUTOR_SUCCESS, LOAD_LISTTUTOR_FAILURE,
      ],
    },
  }
}
export const loadLevel = (endpoint) => {
  return {
    [CALL_API]: {
      endpoint,
      method: 'GET',
      headers,
      types: [LOAD_LEVEL_REQUEST, LOAD_LEVEL_SUCCESS, LOAD_LEVEL_FAILURE],
    },
  }
}
export const handleResetStatus = status => ({
  type: RESET_STATUS_RESPONSE,
  data: status,
})
export const handleSubmitNewUser = (endpoint, loginForm, redirect = null) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: JSON.stringify(loginForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'server-name': 'deknerd',
          // 'x-session-token': token,
        },
        types: [
          REGISTER_NEWUSER_REQUEST,
          {
            type: REGISTER_NEWUSER_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              // const { tokenWeb } = response
              // await sessionService.saveSession({ token: tokenWeb })
              // await sessionService.saveUser({ displayName, imageURL })
              // redirect !== null ? window.location.replace(redirect) : window.location.replace('/')
              // await localStorage.removeItem('password')
              // if (localStorage.getItem('type') === 'facebook') {
              //   await dispatch(handleLogin(LOGIN_FB_EP, localStorage.getItem('token'), redirect))
              // } else if (localStorage.getItem('type') === 'google') {
              //   await dispatch(handleLogin(LOGIN_GG_EP, localStorage.getItem('token'), redirect))
              // } else {
              //   await dispatch(handleLogin(LOGIN_EP, { email: response.email, password: passwordNewUser }, redirect))
              // }
              const { displayName, imageURL, tokenWeb } = response
              await sessionService.saveSession({ token: tokenWeb })
              await sessionService.saveUser({ displayName, imageURL })
              // dispatch(push('/'))
              if (document.referrer.split('/')[3] === 'course') {
                window.location.replace(`/course/${document.referrer.split('/')[4]}`)
              } else {
                redirect !== null ? window.location.replace(redirect) : window.location.replace('/home')
              }
              return response
            },
          },
          {
            type: REGISTER_NEWUSER_FAILURE,
            payload: async (action, state, res) => {
              return res.status
            },
          },
        ],
      },
    })
  }
}
export const submitLineStudentRegister = (endpoint, registerForm, slugName) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'PUT',
        body: JSON.stringify(registerForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-session-token': token,
          'server-name': 'deknerd',
        },
        types: [SIGNUP_REQUEST,
          {
            type: SIGNUP_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              // await dispatch(handleLogin(LOGIN_EP, { email: registerForm.email, password: registerForm.password }, redirect))
              // redirect !== null ? window.location.replace(redirect) : window.location.replace('/instructor/review')
              // const response = await res.json()
              await  dispatch(messagingToLine(slugName, "ขอบคุณที่ให้ความสนใจ\nเรากำลังค้นหาติวเตอร์ให้กับคุณ\nหากพบติวเตอร์แล้วเราจะรีบแจ้งให้ทราบทันที"))
              // await  dispatch(messagingToLine(response.jobId, `ขอบคุณที่ให้ความสนใจ
              //     เรากำลังค้นหาติวเตอร์ให้กับคุณ\n หากพบติวเตอร์แล้ว
              //     เราจะรีบแจ้งให้ทราบทันที`))
              await dispatch(changeRoute(`/lineStudentRegister/${slugName}/success`))
              return response
            },
          },
          {
            type: SIGNUP_FAILURE,
            payload: async (action, state, res) => {
              return res.status
            },
          },
        ],
      },
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/signup.js